import { render, staticRenderFns } from "./AlbumImage.vue?vue&type=template&id=7e39691e&scoped=true&lang=pug&"
import script from "./AlbumImage.vue?vue&type=script&lang=js&"
export * from "./AlbumImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e39691e",
  null
  
)

export default component.exports